import { Action } from "redux";

import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

export interface StrollersBrandsLoadApiAction extends Action {
    readonly after: string;
}

export const STROLLERS_BRANDS_LOAD_API_REQUEST = "STROLLERS_BRANDS_LOAD_API_REQUEST";

export interface StrollersBrandsLoadApiRequestAction
    extends StrollersBrandsLoadApiAction, APIRequestAction {
    readonly type: typeof STROLLERS_BRANDS_LOAD_API_REQUEST;
}

export interface StrollersBrandsLoadApiNormalizedResponse extends NormalizedResponse {
    readonly result: { brands: number[] };
}

export const STROLLERS_BRANDS_LOAD_API_SUCCESS = "STROLLERS_BRANDS_LOAD_API_SUCCESS";

export interface StrollersBrandsLoadApiSuccessAction
    extends
        StrollersBrandsLoadApiAction,
        APISuccessAction<StrollersBrandsLoadApiNormalizedResponse> {
    readonly type: typeof STROLLERS_BRANDS_LOAD_API_SUCCESS;
    readonly hasMore: boolean;
    readonly strollersCountPerBrand: Record<number, number>;
}

export const STROLLERS_BRANDS_LOAD_API_FAILURE = "STROLLERS_BRANDS_LOAD_API_FAILURE";

export interface StrollersBrandsLoadApiFailureAction
    extends StrollersBrandsLoadApiAction, APIFailureAction {
    readonly type: typeof STROLLERS_BRANDS_LOAD_API_FAILURE;
}

export const strollersBrandsLoadApi = {
    request: (after: string): StrollersBrandsLoadApiRequestAction => ({
        type: STROLLERS_BRANDS_LOAD_API_REQUEST,
        after,
    }),
    success: (
        after: string,
        hasMore: boolean,
        strollersCountPerBrand: Record<number, number>,
        response: StrollersBrandsLoadApiNormalizedResponse,
    ): StrollersBrandsLoadApiSuccessAction => ({
        type: STROLLERS_BRANDS_LOAD_API_SUCCESS,
        after,
        hasMore,
        strollersCountPerBrand,
        response,
    }),
    failure: (after: string, error: string): StrollersBrandsLoadApiFailureAction => ({
        type: STROLLERS_BRANDS_LOAD_API_FAILURE,
        after,
        error,
    }),
};

export const STROLLERS_BRANDS_LOAD = "STROLLERS_BRANDS_LOAD";

export interface StrollersBrandsLoadAction extends StrollersBrandsLoadApiAction {
    readonly type: typeof STROLLERS_BRANDS_LOAD;
}

export const strollersBrandsLoad = (after: string): StrollersBrandsLoadAction => ({
    type: STROLLERS_BRANDS_LOAD,
    after,
});
